<template>
  <feed></feed>
</template>

<script>
import Feed from "@/components/Feed";
export default {
  name: "FeedId",
  components: {Feed}
}
</script>

<style scoped>

</style>